import { Popup } from "@/components/Popup";
import { InfoIcon } from "@/designSystemIcons";
import { useTranslation } from "@repo/shared/i18n";

export const TacticPopularityScorePopup = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const { t } = useTranslation("tactics");
  return (
    <Popup
      title={t("popularityScore.title")}
      onClose={onClose}
      titleIcon={
        <InfoIcon innerFill="white" outerFill="var(--color-primary-blue)" />
      }
    >
      <div className="flex flex-col gap-y-8 p-4 small-mobile:p-10 min-w-90 mobile:min-w-144">
        <p className="text-dark-secondary">
          {t("popularityScore.description")}
        </p>
        <img
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fc25/frontend-assets/tactics/popularity-score-description.png"
          }
          alt={t("popularityScore.imageAlt")}
          className="hidden desktop:block w-144 mx-auto"
        />
      </div>
    </Popup>
  );
};
